module.exports = __webpack_public_path__ + "static/img/per14.1024541.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per14.jpg
// module id = 8pnz
// module chunks = 41